export default __webpack_public_path__ + "static/media/ic-practice-test.9a14e47a.svg";